import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

export const companyChecksApi = createApi({
  reducerPath: 'companyChecksApi',
  baseQuery: createBaseQuery('company_checks', { timeout: 0 }),
  endpoints: builder => ({
    updateCompanyCheck: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: 'PUT',
        body: data,
      }),
      transformResponse: ({ result }) => result,
    }),
    deleteCompanyCheck: builder.mutation({
      query: id => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
    }),
    createCompanyCheck: builder.mutation({
      query: data => ({
        url: '/',
        method: 'POST',
        body: data,
      }),
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const {
  useUpdateCompanyCheckMutation,
  useDeleteCompanyCheckMutation,
  useCreateCompanyCheckMutation,
} = companyChecksApi;
